<mat-form-field class="w-full" appearance="outline" [subscriptSizing]="subscriptSizing">
    <input type="text" matInput class="disabled:!text-title" [disabled]="!isEditing" [(ngModel)]="innerValue">
    <button *ngIf="includeEditButton" (click)="onButtonClick()"
    mat-icon-button matSuffix aria-label="edit" type="button">
        <mat-icon [svgIcon]="isEditing ? 'ph-regular-floppy-disk' : 'ph-regular-pencil-simple'"></mat-icon>
    </button>
</mat-form-field>
